import Component from './CardPicker'

export default Component
